// extracted by mini-css-extract-plugin
export var dataCell = "_nk-2";
export var dataRow = "_nk-0";
export var headerRow = "_nk-1";